/**
 * 动态路由配置
 * 需要登录后才能访问
 */

// 管理员路由
export const adminRoutes = [
  {
    path: '/admin',
    component: () => import('@/layouts/basicLayout.vue'),
    meta: { requiresAuth: true, role: 'admin' },
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/dashboard.vue'),
        meta: { title: '数据概览', icon: 'el-icon-data-line' },
      },
      {
        path: 'institution-data',
        name: 'InstitutionData',
        component: () => import('@/views/admin/institution-data.vue'),
        meta: { title: '机构数据查看', icon: 'el-icon-office-building' },
      },
      {
        path: 'institution-map',
        name: 'AdminInstitutionMap',
        component: () => import('@/views/admin/institution-map.vue'),
        meta: { title: '托育机构地图', icon: 'el-icon-map-location' },
      },
      {
        path: 'recruitment',
        name: 'AdminRecruitment',
        component: () => import('@/views/admin/recruitment.vue'),
        meta: { title: '招聘岗位', icon: 'el-icon-suitcase' },
      },
      {
        path: 'industry-standard',
        name: 'AdminIndustryStandard',
        component: () => import('@/views/admin/industry-standard.vue'),
        meta: { title: '行业标准', icon: 'el-icon-document' },
      },
      {
        path: 'standard-detail',
        name: 'StandardDetail',
        component: () => import('@/views/admin/standard-detail.vue'),
        meta: { title: '标准详情', icon: 'el-icon-document' },
      },
      {
        path: 'local-standard-detail',
        name: 'LocalStandardDetail',
        component: () => import('@/views/admin/local-standard-detail.vue'),
        meta: { title: '地方标准详情', icon: 'el-icon-document' },
      },
      {
        path: 'my-standards',
        name: 'MyStandards',
        component: () => import('@/views/admin/my-standards.vue'),
        meta: { title: '我的标准', icon: 'el-icon-document' },
      },
      {
        path: 'policy',
        name: 'AdminPolicy',
        component: () => import('@/views/admin/policy.vue'),
        meta: { title: '政策法规', icon: 'el-icon-collection' },
      },
      {
        path: 'policy/detail/national',
        name: 'PolicyDetailNational',
        component: () => import('@/views/admin/policy-detail-national.vue'),
        meta: {
          title: '国家政策详情',
          icon: 'el-icon-collection',
          hidden: true,
        },
      },
      {
        path: 'policy/detail/local',
        name: 'PolicyDetailLocal',
        component: () => import('@/views/admin/policy-detail-local.vue'),
        meta: {
          title: '地方政策详情',
          icon: 'el-icon-collection',
          hidden: true,
        },
      },
      {
        path: 'analysis-report',
        name: 'AnalysisReport',
        component: () => import('@/views/admin/analysis-report.vue'),
        meta: { title: '分析报告', icon: 'el-icon-data-analysis' },
      },
      {
        path: 'ppt-report',
        name: 'PPTReport',
        component: () => import('@/views/admin/ppt-report.vue'),
        meta: { title: 'PPT报告', icon: 'el-icon-document-copy', hidden: true },
      },
      {
        path: 'fill-form',
        name: 'AdminFillForm',
        component: () => import('@/views/practitioner/fill-form.vue'),
        meta: { title: '查看填报', hidden: true },
      },
      {
        path: '',
        redirect: 'dashboard',
        hidden: true,
      },
    ],
  },
]

// 从业人员路由
export const practitionerRoutes = [
  {
    path: '/practitioner',
    component: () => import('@/layouts/basicLayout.vue'),
    meta: { requiresAuth: true, role: 'practitioner' },
    children: [
      {
        path: 'data-fill',
        name: 'DataFill',
        component: () => import('@/views/practitioner/data-fill.vue'),
        meta: { title: '数据填报', icon: 'el-icon-edit' },
      },
      {
        path: 'fill-list',
        name: 'FillList',
        component: () => import('@/views/practitioner/fill-list.vue'),
        meta: { title: '填报列表', icon: 'el-icon-tickets' },
      },
      {
        path: 'fill-form',
        name: 'FillForm',
        component: () => import('@/views/practitioner/fill-form.vue'),
        meta: { title: '填报表单', icon: 'el-icon-edit', hidden: true },
      },
      {
        path: 'institution-map',
        name: 'PractitionerInstitutionMap',
        component: () => import('@/views/practitioner/institution-map.vue'),
        meta: { title: '托育机构地图', icon: 'el-icon-map-location' },
      },
      {
        path: 'recruitment',
        name: 'PractitionerRecruitment',
        component: () => import('@/views/practitioner/recruitment.vue'),
        meta: { title: '招聘岗位', icon: 'el-icon-suitcase' },
      },
      {
        path: 'industry-standard',
        name: 'PractitionerIndustryStandard',
        component: () => import('@/views/practitioner/industry-standard.vue'),
        meta: { title: '行业标准', icon: 'el-icon-document' },
      },
      {
        path: 'standard-detail',
        name: 'PractitionerStandardDetail',
        component: () => import('@/views/practitioner/standard-detail.vue'),
        meta: { title: '标准详情', icon: 'el-icon-document', hidden: true },
      },
      {
        path: 'local-standard-detail',
        name: 'PractitionerLocalStandardDetail',
        component: () =>
          import('@/views/practitioner/local-standard-detail.vue'),
        meta: { title: '地方标准详情', icon: 'el-icon-document', hidden: true },
      },
      {
        path: 'policy',
        name: 'PractitionerPolicy',
        component: () => import('@/views/practitioner/policy.vue'),
        meta: { title: '政策法规', icon: 'el-icon-collection' },
      },
      {
        path: 'policy/detail/national',
        name: 'PractitionerPolicyDetailNational',
        component: () =>
          import('@/views/practitioner/policy-detail-national.vue'),
        meta: {
          title: '国家政策详情',
          icon: 'el-icon-collection',
          hidden: true,
        },
      },
      {
        path: 'policy/detail/local',
        name: 'PractitionerPolicyDetailLocal',
        component: () => import('@/views/practitioner/policy-detail-local.vue'),
        meta: {
          title: '地方政策详情',
          icon: 'el-icon-collection',
          hidden: true,
        },
      },
      {
        path: '',
        redirect: 'data-fill',
        hidden: true,
      },
    ],
  },
]

// 超级管理员路由
export const superAdminRoutes = [
  {
    path: '/superadmin',
    component: () => import('@/layouts/superAdminLayout.vue'),
    meta: { requiresAuth: true, role: 'superadmin' },
    children: [
      {
        path: 'user-management',
        name: 'SuperAdminUserManagement',
        component: () => import('@/views/superadmin/user-management.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user' },
      },
      {
        path: 'fill-time-management',
        name: 'SuperAdminFillTimeManagement',
        component: () => import('@/views/superadmin/fill-time-management.vue'),
        meta: { title: '填报时间管理', icon: 'el-icon-time' },
      },
      {
        path: '',
        redirect: 'user-management',
        hidden: true,
      },
    ],
  },
]

// 合并所有动态路由
export const asyncRoutes = [
  ...adminRoutes,
  ...practitionerRoutes,
  ...superAdminRoutes,
]
